import modalStyle from 'components/Modal/Modal.module.scss';

import { useBreakpoints } from 'hooks/useBreakpoints';
import React from 'react';
import LazyLoad from 'react-lazyload';

export interface IProps {
  offset?: number;
  children: React.ReactNode;
}

export const LazyLoader = ({ offset, children }: IProps) => {
  const { browser } = useBreakpoints();
  const isMobile = browser.is.mobile;
  const windowInnerHeight = window.innerHeight;
  const defaultImageOffset = isMobile ? windowInnerHeight : windowInnerHeight * 2;
  const imageOffset = offset ? offset : defaultImageOffset;
  const isModalActive = Boolean(document.querySelector(`.${modalStyle.modal}`));

  return (
    <LazyLoad offset={imageOffset} height="100%" overflow={isModalActive} data-overflow={isModalActive}>
      {children}
    </LazyLoad>
  );
};
